import axios from 'axios';

export function globalScrollToErrorField(errorClassName: string): void {
  const errorFieldsElements = document.getElementsByClassName(errorClassName);
  if (errorFieldsElements && errorFieldsElements.length > 0) {
    errorFieldsElements[0].scrollIntoView({
      block: 'center',
      behavior: 'smooth'
    });
  }
}

export function scrollToElementBasedOnId(
  elementId: string,
  position: ScrollLogicalPosition = 'center'
): void {
  const element = document.getElementById(elementId);
  if (element) {
    element.scrollIntoView({
      block: position,
      behavior: 'smooth'
    });
  }
}

export const downloadFileFromSignedURL = (
  signedUrl: string,
  fileName: string
): void => {
  axios
    .get(signedUrl, { responseType: 'blob' })
    .then((response) => {
      // Create a URL object from the response data (blob= Binary Large Object)
      const url = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement('a');
      link.href = url;

      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
    })
    .catch((error) => {
      console.error('Error downloading the file:', error);
    });
};

export const copyTextToClipboard = (text: string): void => {
  navigator.clipboard.writeText(text);
};

export const downloadTextFile = (content: string, filename: string): void => {
  const blob = new Blob([content], { type: 'text/plain' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

export const scrollToWindowTop = (): void => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

export const getWindowInnerHeight = (): number => {
  return window.innerHeight;
};

export const reloadWindow = (): void => {
  window.location.reload();
};
